var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkgAzzurro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1233.5 878.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n        opacity: .3;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        fill: url(#Sfumatura_senza_nome_3471);\n      }\n\n      .st3 {\n        fill: url(#Sfumatura_senza_nome_260);\n      }\n\n      .st3, .st4 {\n        mix-blend-mode: multiply;\n      }\n\n      .st3, .st4, .st5, .st6 {\n        opacity: .5;\n      }\n\n      .st4 {\n        fill: url(#Sfumatura_senza_nome_339);\n      }\n\n      .st5 {\n        fill: url(#Sfumatura_senza_nome_342);\n      }\n\n      .st6 {\n        fill: url(#Sfumatura_senza_nome_415);\n      }\n\n      .st7 {\n        fill: url(#Sfumatura_senza_nome_252);\n      }\n\n      .st8 {\n        fill: url(#Sfumatura_senza_nome_145);\n      }\n\n      .st9 {\n        fill: url(#Sfumatura_senza_nome_144);\n      }\n\n      .st10 {\n        fill: url(#Sfumatura_senza_nome_216);\n      }\n\n      .st11 {\n        fill: url(#Sfumatura_senza_nome_202);\n      }\n\n      .st12 {\n        fill: url(#Sfumatura_senza_nome_429);\n      }\n\n      .st13 {\n        fill: url(#Sfumatura_senza_nome_424);\n      }\n\n      .st14 {\n        fill: url(#Sfumatura_senza_nome_347);\n      }\n\n      .st15 {\n        fill: url(#Sfumatura_senza_nome_338);\n      }\n\n      .st16 {\n        fill: url(#Sfumatura_senza_nome_372);\n      }\n\n      .st17 {\n        fill: url(#Sfumatura_senza_nome_382);\n      }\n\n      .st18 {\n        fill: url(#Sfumatura_senza_nome_377);\n      }\n\n      .st19 {\n        fill: url(#Sfumatura_senza_nome_419);\n      }\n\n      .st20 {\n        fill: url(#Sfumatura_senza_nome_402);\n      }\n\n      .st21 {\n        fill: url(#Sfumatura_senza_nome_430);\n      }\n\n      .st22 {\n        fill: url(#Sfumatura_senza_nome_432);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_347",
    "data-name": "Sfumatura senza nome 347",
    x1: 256.9,
    y1: 1090.3,
    x2: -350.8,
    y2: 512.6,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71cbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_216",
    "data-name": "Sfumatura senza nome 216",
    x1: 858.7,
    y1: 1516.9,
    x2: 56.3,
    y2: 789.4,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bce4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_252",
    "data-name": "Sfumatura senza nome 252",
    x1: 796.4,
    y1: 1647.3,
    x2: -188.4,
    y2: 754.4,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bce4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_382",
    "data-name": "Sfumatura senza nome 382",
    x1: 255.8,
    y1: 1546.8,
    x2: -682.4,
    y2: 436.6,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6dc1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3eb2e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1ca7e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#07a0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_372",
    "data-name": "Sfumatura senza nome 372",
    x1: 265.1,
    y1: 1386.1,
    x2: -661.2,
    y2: 481.8,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#73c3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#35afe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0ea2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3471",
    "data-name": "Sfumatura senza nome 347",
    x1: 146.6,
    y1: 1712.6,
    x2: -525.1,
    y2: 918.9,
    xlinkHref: "#Sfumatura_senza_nome_347"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_145",
    "data-name": "Sfumatura senza nome 145",
    x1: 905.8,
    y1: 1529.2,
    x2: 29.4,
    y2: 874.1,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71cbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#bce4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_419",
    "data-name": "Sfumatura senza nome 419",
    x1: 1493.7,
    y1: 1248.2,
    x2: -143.7,
    y2: 1000.5,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71cbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6bc8f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5ac1f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3eb7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#18a7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_432",
    "data-name": "Sfumatura senza nome 432",
    x1: 19.1,
    y1: 707.4,
    x2: 617.9,
    y2: 1375.2,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#81c7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#49b5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#21a8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#09a0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_429",
    "data-name": "Sfumatura senza nome 429",
    x1: 994.9,
    y1: 1483.8,
    x2: -330.6,
    y2: 898.7,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bce4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#88d2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#77cdf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#71cbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_430",
    "data-name": "Sfumatura senza nome 430",
    x1: 122,
    y1: 945.5,
    x2: 604.1,
    y2: 1339.9,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#76c4ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#50b8ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#14a4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_424",
    "data-name": "Sfumatura senza nome 424",
    x1: 719.7,
    y1: 1442.3,
    x2: -35.7,
    y2: 937.7,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bce4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#71cbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_202",
    "data-name": "Sfumatura senza nome 202",
    x1: 852.2,
    y1: 1873.5,
    x2: 272.6,
    y2: 1060.8,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#bce4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_342",
    "data-name": "Sfumatura senza nome 342",
    x1: -495.9,
    y1: 849.5,
    x2: 735,
    y2: 849.5,
    gradientTransform: "translate(737.3982 1188.9727) rotate(-180) scale(1 1.0748)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71cbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6cc9f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5fc4f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#49bbed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2bafe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#049fe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_338",
    "data-name": "Sfumatura senza nome 338",
    x1: 793.6,
    y1: 1753.2,
    x2: 174.5,
    y2: 1020.7,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bce4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_402",
    "data-name": "Sfumatura senza nome 402",
    x1: -44.3,
    y1: 1463.8,
    x2: -428.3,
    y2: 985.8,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7fc7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6fc1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#54b9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2fade6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_377",
    "data-name": "Sfumatura senza nome 377",
    x1: 153.4,
    y1: 865.4,
    x2: 588.8,
    y2: 1372.5,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71cbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#51beee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2eb0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#14a6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#05a0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_415",
    "data-name": "Sfumatura senza nome 415",
    x1: 1064.5,
    y1: 624.2,
    x2: 1308.2,
    y2: 749.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#85c9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#009ee1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_260",
    "data-name": "Sfumatura senza nome 260",
    x1: 618.2,
    y1: 876.2,
    x2: 618.2,
    y2: 619.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_339",
    "data-name": "Sfumatura senza nome 339",
    x1: 314.4,
    y1: -872.1,
    x2: 314.4,
    y2: -1301.7,
    gradientTransform: "translate(0 -866.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ee1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#039fe1",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0ca2e2",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1ba6e4",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#31ade6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4cb6e9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6dc1ed",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85c9f0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_144",
    "data-name": "Sfumatura senza nome 144",
    x1: 319.4,
    y1: 1118.9,
    x2: 195.7,
    y2: 976.6,
    gradientTransform: "translate(737.3982 1398.075) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63c0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5dbeed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4fb9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#37b1e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#16a5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    x: 2.4,
    width: 1231,
    height: 876.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M986,2H3v875h297.3c83.7-43.9,165.9-98.3,244-163C789.6,510.8,943.3,248.9,986,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1232.6,1.1H1v724.6c134.1,6.8,278.1-3.1,425.6-31.9,348.9-68.2,639.8-227.3,806-417.8V1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M798.3,878.8h435V88.2c-13.6-1-27.1-2.1-40.6-3.1-79.7-5.9-160.3-12.9-239.9-17.9,2.7,26.2,5.6,52.4,8.5,78.5,2.7,23.2,5.4,46.3,7.9,69.6,17.5,149.5,17.5,304.8-42.2,446.1-32.8,78.7-79.6,148.8-128.6,217.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M895.5,878.8h337.8V302.9c-98.3-110.1-222.8-145.6-222.8-145.6,0,0,15.9,30.1,23.9,160.3,8,130.3,2,214.4-39.8,360.7-17.2,60.1-57.5,134.1-99.1,200.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1191.5,85c-79.7-5.9-160.3-12.9-239.9-17.9,2.7,26.2,5.6,52.4,8.5,78.5,2.7,23.2,5.4,46.3,7.9,69.6,10.6,90.6,14.8,183.3,3.2,273.7,104.4-63.1,192.7-135.4,260.3-213V88.1c-13.3-1-26.6-2-39.9-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M426,693.8c67.6-13.2,133.1-29.9,195.9-49.5C821.7,452.9,947.4,221.5,985.4,2H2.4v723.8c133.5,6.6,276.8-3.3,423.7-32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3,2v661.5C685.6,729.1,854,220.3,902.1,2H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M0,2v664.6c46.2-6.9,92.5-16.4,138.4-28.6,33.4-8.8,66.5-19.1,99.1-30.8,187.1-67.1,361.2-179.3,464.7-358.7,45.4-78.7,74.8-161.5,95.3-246.5H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M512.7,140.3c173.5-43.9,325.1-56.5,452.8-52.4,7.9-28.8,14.3-57.4,19.2-85.9H2.4v487.6c98.2-142.4,256.6-285.1,510.3-349.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M660.3,104.9s-50.5,233.3-286.6,295.4c-236.1,62.1-326.1-28.1-326.1-28.1,0,0-53.4-128.8,29.9-230.6,83.3-101.9,582.8-36.6,582.8-36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M512.7,140.3c136-34.4,258.6-49.6,366.7-52.6,9.3-31.5,16.5-60.6,22-85.7H2.4v487.6c98.2-142.4,256.6-285.1,510.3-349.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M512.7,140.3c92.1-23.3,178.1-37.8,257.5-45.6,10.3-30.5,19-61.4,26.6-92.7H2.4v487.6c98.2-142.4,256.6-285.1,510.3-349.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2.4,485.4c60.1-82.9,133.5-155,217.4-212,54.9-37.3,114-67.6,175.4-91.6,71.3-27.8,145.9-45.8,220.6-60.3,131.3-25.5,265.7-35.9,399.1-26.5,73.6,5.2,146.9,16.6,218.5,35v-26c-98.2-25-199.4-36.7-300.5-37.7-144.1-1.4-287.8,19.4-427.4,55.6-126.9,32.9-247.2,91.4-349.5,176.2-42.8,35.4-82.1,75.3-117.6,118.5-12.5,15.2-24.5,30.9-36,47v21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1.9,1v254.5c29.1-31.5,65-64.5,109.4-98.2C344.1-19,751.9,59.1,751.9,59.1L691.1,1H1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1034.4,315.6c2.9,47.4,3.9,88.7,2.1,129.1,70.9-48.8,132.7-102,183.6-158.1-95.9-98.9-209.5-131.4-209.5-131.4,0,0,15.9,30.1,23.9,160.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M677.4,200.5c-204,13.9-368.1,159.2-484.5,317.5,173.1-43.1,340.2-134.3,451.9-276.2,23.7-27.2,32.6-41.3,32.6-41.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1233.5,358.9s-315.6,239.9-359.2,519.9h359.2V358.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1232.6,878.8S798.4,648.2,3.9,624.1v254.7h1228.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M625,.9S386.8,362.5,3.9,427.8V.9h621.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M275.3,418.1c29.8-3.2,62.8-9.2,99.3-18.8,130.7-34.4,204.5-121.2,244.4-191.9-134.6,26.6-250,109.6-343.8,210.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 3.9,
    y: 0.9,
    width: 1228.7,
    height: 877.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgAzzurro);
export default __webpack_public_path__ + "static/media/bkg-azzurro.f6d6b9406120de9dc82cbafec27234a5.svg";
export { ForwardRef as ReactComponent };